<!--
Author: TangChen
Date: 2018-10-17
Desc: 修改交易密码密码页面，由index.js 配置引入
 -->
<template>
    <div>
        <div :class="'bizcomp-change-tpwd bizcomp ' + className">
            <change-pwd :way="way" />
        </div>
        <footer-questions
            v-if="$const.warmReminderDisplay"
            :warning-html="warningHtml"
        ></footer-questions>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import changePwd from "@/components/acctInfo/changePwdDc.vue";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";

export default {
    name: "ChangeTpwd",
    components: {
        changePwd,
        footerQuestions
    },
    mixins: [mixin],
    data() {
        return {
            way: "trade",
            warningHtml: ""
        };
    },
    mounted() {
        this.warningHtml = warningHtml.warningHtml2;
    },
    methods: {}
};
</script>
<style lang="scss" scoped>
.bizcomp-change-tpwd {
}
</style>
